import { defineComponent as _defineComponent } from 'vue'
import { ContactHealthScoreModel } from '@/types';
import {
    getContactHealthScoreTrend,
    getContactHealthScoreStatus,
} from '@/utils/contactHealthScore';
import { computed } from 'vue';

interface Props {
    healthScore: ContactHealthScoreModel | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactHealthScoreChart',
  props: {
    healthScore: { type: [Object, null], required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;
const healthScore = computed(() => props.healthScore?.score ?? null);
const trendScore = computed(() => props.healthScore?.trend ?? null);
const circumference = 2 * Math.PI * 42;
const dash = computed(() =>
    healthScore.value !== null ? (healthScore.value / 100) * circumference : 0,
);

const scoreColor = (score: number) => {
    if (score >= 70) return 'text-success';
    if (score >= 45) return 'text-warning';
    return 'text-danger';
};

const __returned__ = { props, healthScore, trendScore, circumference, dash, scoreColor, get getContactHealthScoreTrend() { return getContactHealthScoreTrend }, get getContactHealthScoreStatus() { return getContactHealthScoreStatus } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})